// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../CourseImages/CeoMsgBg.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PolymatchBg{
    background:  url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: cover;
    background-position: center;
    width: 100%;
    height: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 5%;
}
.PolymatchWords {
    display: flex;
    justify-content: center;
    gap: -10px;
    margin-top: 0px;
    font-size: 1.8rem;
    color: #6d0283;
    font-family: 'Belanosima';
}

.PolymatchWords p {
    margin: 0;
    font-weight: bold;
}
.PolymatchWords p:nth-child(1) {
    color: rgb(139, 1, 148);  /* Mastery */
}

.PolymatchWords p:nth-child(2) {
    color: rgb(182, 3, 96);  /* Achieve */
}

.PolymatchWords p:nth-child(3) {
    color: rgb(227, 206, 24);  /* Thrive */
}

.PolymatchWords p:nth-child(4) {
    color: rgb(71, 150, 63);  /* Compete */
}

.PolymatchWords p:nth-child(5) {
    color: rgb(227, 206, 24);  /* Hone */
}

.PolymatchHeading {
    margin-top: 20px;
    margin-bottom: 0px;
    font-size: 1.5rem;
    font-weight: bold;
    color: rgb(182, 3, 96);
    text-align: center;
    font-family: 'Belanosima';
}
.PolymatchSection_1{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}
.PolymatchSection_1 img{
    width:30% ;
    height: 30%;
}
.PolymatchSection_1 p{
    padding: 0 1vh 0 1vh;
    font-size: 2.5vh;
    font-family: cursive;
    font-weight: bold;
    text-align: justify;
    color: #8b0194;
    width: 70%;
    margin-bottom: 20px;
}


.PolymatchSection_2 {
    display: flex;
    flex-wrap: wrap; /* Allows wrapping of items */
    align-items: center;
    justify-content: space-between;
    width: 80%;
    gap: 10px; /* Consistent spacing */
    margin-top: 20px; /* Add space above the section if needed */
    margin-left: 10px;
}
.PolymatchSection_2 > div {
    flex: 1 1 30%; /* Adjust the width of each item */
    box-sizing: border-box; /* Ensures padding and border are included in the element's total width and height */
    max-width: 30%;
    text-align: center
}
.Polymatch_MathMental,.Polymatch_Islamic,.Polymatch_Linguist,.Polymatch_Science,.Polymatch_IQ{
    background-color: #dbaf1f;
    width: 300px; /* Set a fixed width */
    height: 90px; /* Set a fixed height */
    padding: 15px; /* Uniform padding */
    border-radius: 8px; /* Rounded corners */
    text-align: center;
    cursor: pointer;
    transition: background-color 0.3s ease; /* Smooth hover effect */
    display: flex; /* Flex to center content */
    flex-direction: column; /* Stack content vertically */
    justify-content: center; /* Center content vertically */
    align-items: center; /* Center content horizontally */
}
.Polymatch_Science{
    background-color: rgba(231, 3, 182, 0.637)
}
.Polymatch_IQ{
    background-color: rgba(236, 138, 25, 0.555)
}
.Polymatch_Islamic{
    background-color: rgb(78, 237, 64)
}

.Polymatch_Linguist{
    background-color: #688cd9;
}

.Polymatch_MathMental p,
.Polymatch_Islamic p,
.Polymatch_MathMental a,
.Polymatch_Islamic a,
.Polymatch_Linguist p,
.Polymatch_Linguist a,
.Polymatch_Science a,
.Polymatch_Science p,
.Polymatch_IQ a,
.Polymatch_IQ p{
    text-align: center;
    color: white;
    font-weight: bold;
    font-size: medium;
    align-items: center;
    
}


.PolymatchSection_3 {
    font-family: 'Comic Sans MS', cursive, sans-serif;
    color: #730099;
    background-color: #eaf6ff;
    padding: 20px;
    border-radius: 10px;
    /* max-width: 800px; */
    /* margin: 0 auto; */
    text-align: center;
    margin-left: 150px;
}
.Polymatch_header{
    display: flex;
    align-items: center;
    justify-content: space-around;
    margin-bottom: 0px;
}
.Polymatch_header h1 {
    font-size: 36px;
    margin: 0;
}

.Polymatch_header h2 {
    font-size: 24px;
    margin: 0;
}

.Polymatch_dateBadge {
    background-color: #d399ff;
    border-radius: 50%; /* Perfect circle */
    padding: 0; /* Ensure no extra padding affects centering */
    height: 16.5vh; /* Adjust the height */
    width: 16.5vh; /* Match the width with height for a perfect circle */
    display: flex;
    justify-content: center; /* Horizontally center content */
    align-items: center; /* Vertically center content */
    white-space: nowrap; /* Prevent text wrapping */
    text-align: center; /* Centers the text horizontally inside flex */
    margin-right: 100px;
    margin-left: 80px;
    
}
.Polymatch_dateBadges {
    background-color: #d399ff;
    border-radius: 50%; /* Perfect circle */
    padding: 0; /* Ensure no extra padding affects centering */
    height: 16.5vh; /* Adjust the height */
    width: 16.5vh; /* Match the width with height for a perfect circle */
    display: flex;
    justify-content: center; /* Horizontally center content */
    align-items: center; /* Vertically center content */
    white-space: nowrap; /* Prevent text wrapping */
    text-align: center; /* Centers the text horizontally inside flex */
    margin-right: 100px;
    margin-left: 20px;
}
.Polymatch_dateBadges p {
    margin: 0; /* Remove default paragraph margins */
    font-size: 1.5vh; /* Adjust font size proportionally */
    font-family: 'Barlow, sans-serif';
    font-weight: bold;
    text-align: center;
}

.Polymatch_dateBadge p {
    margin: 0; /* Remove default paragraph margins */
    font-size: 1.5vh; /* Adjust font size proportionally */
    font-family: 'Barlow, sans-serif';
    font-weight: bold;
    text-align: center;
}


.Polymatch_content p {
    padding: 10px;
    border-radius: 10px;
    margin: 80px 90;
    text-align: justify;
    font-weight: lighter;
    margin-top: 0px;
    margin-left: 90px;
    font-family: Baumans; font-size: 20px; font-weight: 400
}
.results-btn {
    display: inline-block; /* Ensures the button stays inline */
    padding: 10px 20px; /* Adjust padding for proper alignment */
    background: linear-gradient(to bottom, rgb(255, 255, 255) 0%, rgb(139, 1, 148) 100%);
    color: white;
    text-align: center;
    text-decoration: none;
    font-size: 16px;
    border-radius: 8px;
    white-space: nowrap; /* Prevents text wrapping */
    transition: background-color 0.3s ease;
    margin-top: 0; /* Remove extra margin if causing misalignment */
}

.results-btn:hover {
    background-color: #483d8b; /* Darker Slate Blue */
}

.reg-btn {
    display: inline-block; /* Ensures the button stays inline */
    padding: 10px 20px; /* Adjust padding for proper alignment */
    background: linear-gradient(to bottom, rgb(255, 255, 255) 0%, rgb(139, 1, 148) 100%);
    color: white;
    text-align: center;
    text-decoration: none;
    font-size: 16px;
    border-radius: 8px;
    white-space: nowrap; /* Prevents text wrapping */
    transition: background-color 0.3s ease;
    margin-top: 0; /* Remove extra margin if causing misalignment */
    align-items: center;
}

.reg-btn:hover {
    background-color: #483d8b; /* Darker Slate Blue */
}

.regs-button {
    display: flex; /* Enables flexbox */
    justify-content: center; /* Centers horizontally */
    align-items: center; /* Centers vertically */
    height: 100%; /* Adjust the height if needed */
    width: 100%; /* Ensure it spans the full width of the container */
    text-align: center; /* Aligns text if applicable */
}


.Polymatch_participantsSection {
    margin-top: 20px;
    margin-right: 150px;
    width: -moz-fit-content;
    width: fit-content;
}

.Polymatch_participantsSection h3 {
    color: #ff5733;
    font-size: 3vh;
}

.Polymatch_flagsGrid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 10px;
    justify-items: center;
    
}
.Polymatch_flagsGrids {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 5px;
    justify-items: center;
    
}
.Polymatch_flagsGridss {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 15px;
    justify-items: center;
    /* margin-right: 90px; */
}
.PolymatchFlagSection{
    display: flex;
    align-items: center;
    /* justify-content: space-around; */
    margin-left: 5vh;
}
.Polymatch_flag{
    width: 80%;
    height: 80%;
}

.gallery_container {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
    justify-content: center;
}

.gallery_image {
    width: 100%;
    height: auto;
    border-radius: 10px;
}

@media (max-width: 768px) {
    .PolymatchSection_2{
        flex-direction: column;
    }
    .PolymatchFlagSection{
        flex-direction: column;
        margin-left:0 ;
    }
    .Polymatch_content{
        width: auto;
    }
    .Polymatch_content p{
        text-align: justify;
        width: 100%;
    }
    .Polymatch_dateBadge{
        height: auto;
        width: auto;
    }
}

@media (max-width: 768px) {
    .gallery_image {
        max-width: 100%;
    }
}

@media (max-width: 480px) {
    .gallery_image {
        max-width: 80%;
    }
}
.PolymatchButtons {
    display: flex;
    gap: 20px;
    margin-top: 20px;
}

.polymatch-btn {
    background-color: rgb(139, 1, 148);
    color: white;
    padding: 15px 30px;
    border-radius: 30px;
    text-decoration: none;
    font-weight: bold;
    text-align: center;
    transition: background-color 0.3s ease;
    margin-bottom: 20px;
    /* cursor: not-allowed; Change cursor to indicate the button is disabled  */
    /* opacity: 0.6; Reduce opacity to make it look disabled */
    /* pointer-events: none; Disable click events */
}

.polymatch-btn.details {
    background-color: rgb(139, 1, 148);
}

.polymatch-btn:hover {
    background-color: #e64e2d;
}

.polymatch-btn.details:hover {
    background-color: #5078b4;
}

@media (max-width: 768px) {
    .PolymatchButtons {
        flex-direction: column;
        align-items: center;
        gap: 10px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/MyComponents/PromotionalPages/Polymatch.css"],"names":[],"mappings":"AAAA;IACI,oDAAgD;IAChD,sBAAsB;IACtB,2BAA2B;IAC3B,WAAW;IACX,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;AACf;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,UAAU;IACV,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,SAAS;IACT,iBAAiB;AACrB;AACA;IACI,uBAAuB,GAAG,YAAY;AAC1C;;AAEA;IACI,sBAAsB,GAAG,YAAY;AACzC;;AAEA;IACI,wBAAwB,GAAG,WAAW;AAC1C;;AAEA;IACI,uBAAuB,GAAG,YAAY;AAC1C;;AAEA;IACI,wBAAwB,GAAG,SAAS;AACxC;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,iBAAiB;IACjB,sBAAsB;IACtB,kBAAkB;IAClB,yBAAyB;AAC7B;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;IACI,UAAU;IACV,WAAW;AACf;AACA;IACI,oBAAoB;IACpB,gBAAgB;IAChB,oBAAoB;IACpB,iBAAiB;IACjB,mBAAmB;IACnB,cAAc;IACd,UAAU;IACV,mBAAmB;AACvB;;;AAGA;IACI,aAAa;IACb,eAAe,EAAE,6BAA6B;IAC9C,mBAAmB;IACnB,8BAA8B;IAC9B,UAAU;IACV,SAAS,EAAE,uBAAuB;IAClC,gBAAgB,EAAE,0CAA0C;IAC5D,iBAAiB;AACrB;AACA;IACI,aAAa,EAAE,kCAAkC;IACjD,sBAAsB,EAAE,oFAAoF;IAC5G,cAAc;IACd;AACJ;AACA;IACI,yBAAyB;IACzB,YAAY,EAAE,sBAAsB;IACpC,YAAY,EAAE,uBAAuB;IACrC,aAAa,EAAE,oBAAoB;IACnC,kBAAkB,EAAE,oBAAoB;IACxC,kBAAkB;IAClB,eAAe;IACf,sCAAsC,EAAE,wBAAwB;IAChE,aAAa,EAAE,2BAA2B;IAC1C,sBAAsB,EAAE,6BAA6B;IACrD,uBAAuB,EAAE,8BAA8B;IACvD,mBAAmB,EAAE,gCAAgC;AACzD;AACA;IACI;AACJ;AACA;IACI;AACJ;AACA;IACI;AACJ;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;;;;;;;;;;IAUI,kBAAkB;IAClB,YAAY;IACZ,iBAAiB;IACjB,iBAAiB;IACjB,mBAAmB;;AAEvB;;;AAGA;IACI,iDAAiD;IACjD,cAAc;IACd,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,oBAAoB;IACpB,kBAAkB;IAClB,kBAAkB;AACtB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,6BAA6B;IAC7B,kBAAkB;AACtB;AACA;IACI,eAAe;IACf,SAAS;AACb;;AAEA;IACI,eAAe;IACf,SAAS;AACb;;AAEA;IACI,yBAAyB;IACzB,kBAAkB,EAAE,mBAAmB;IACvC,UAAU,EAAE,8CAA8C;IAC1D,cAAc,EAAE,sBAAsB;IACtC,aAAa,EAAE,qDAAqD;IACpE,aAAa;IACb,uBAAuB,EAAE,gCAAgC;IACzD,mBAAmB,EAAE,8BAA8B;IACnD,mBAAmB,EAAE,0BAA0B;IAC/C,kBAAkB,EAAE,8CAA8C;IAClE,mBAAmB;IACnB,iBAAiB;;AAErB;AACA;IACI,yBAAyB;IACzB,kBAAkB,EAAE,mBAAmB;IACvC,UAAU,EAAE,8CAA8C;IAC1D,cAAc,EAAE,sBAAsB;IACtC,aAAa,EAAE,qDAAqD;IACpE,aAAa;IACb,uBAAuB,EAAE,gCAAgC;IACzD,mBAAmB,EAAE,8BAA8B;IACnD,mBAAmB,EAAE,0BAA0B;IAC/C,kBAAkB,EAAE,8CAA8C;IAClE,mBAAmB;IACnB,iBAAiB;AACrB;AACA;IACI,SAAS,EAAE,qCAAqC;IAChD,gBAAgB,EAAE,oCAAoC;IACtD,iCAAiC;IACjC,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,SAAS,EAAE,qCAAqC;IAChD,gBAAgB,EAAE,oCAAoC;IACtD,iCAAiC;IACjC,iBAAiB;IACjB,kBAAkB;AACtB;;;AAGA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,mBAAmB;IACnB,oBAAoB;IACpB,eAAe;IACf,iBAAiB;IACjB,oBAAoB,EAAE,eAAe,EAAE;AAC3C;AACA;IACI,qBAAqB,EAAE,oCAAoC;IAC3D,kBAAkB,EAAE,wCAAwC;IAE5D,oFAAoF;IACpF,YAAY;IACZ,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;IACf,kBAAkB;IAClB,mBAAmB,EAAE,2BAA2B;IAChD,sCAAsC;IACtC,aAAa,EAAE,gDAAgD;AACnE;;AAEA;IACI,yBAAyB,EAAE,sBAAsB;AACrD;;AAEA;IACI,qBAAqB,EAAE,oCAAoC;IAC3D,kBAAkB,EAAE,wCAAwC;IAE5D,oFAAoF;IACpF,YAAY;IACZ,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;IACf,kBAAkB;IAClB,mBAAmB,EAAE,2BAA2B;IAChD,sCAAsC;IACtC,aAAa,EAAE,gDAAgD;IAC/D,mBAAmB;AACvB;;AAEA;IACI,yBAAyB,EAAE,sBAAsB;AACrD;;AAEA;IACI,aAAa,EAAE,oBAAoB;IACnC,uBAAuB,EAAE,yBAAyB;IAClD,mBAAmB,EAAE,uBAAuB;IAC5C,YAAY,EAAE,gCAAgC;IAC9C,WAAW,EAAE,oDAAoD;IACjE,kBAAkB,EAAE,8BAA8B;AACtD;;;AAGA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,uBAAkB;IAAlB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;IACT,qBAAqB;;AAEzB;AACA;IACI,aAAa;IACb,qCAAqC;IACrC,QAAQ;IACR,qBAAqB;;AAEzB;AACA;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;IACT,qBAAqB;IACrB,wBAAwB;AAC5B;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,mCAAmC;IACnC,gBAAgB;AACpB;AACA;IACI,UAAU;IACV,WAAW;AACf;;AAEA;IACI,aAAa;IACb,eAAe;IACf,SAAS;IACT,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI;QACI,sBAAsB;IAC1B;IACA;QACI,sBAAsB;QACtB,cAAc;IAClB;IACA;QACI,WAAW;IACf;IACA;QACI,mBAAmB;QACnB,WAAW;IACf;IACA;QACI,YAAY;QACZ,WAAW;IACf;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,cAAc;IAClB;AACJ;AACA;IACI,aAAa;IACb,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,kCAAkC;IAClC,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,qBAAqB;IACrB,iBAAiB;IACjB,kBAAkB;IAClB,sCAAsC;IACtC,mBAAmB;IACnB,2EAA2E;IAC3E,0DAA0D;IAC1D,+CAA+C;AACnD;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI;QACI,sBAAsB;QACtB,mBAAmB;QACnB,SAAS;IACb;AACJ","sourcesContent":[".PolymatchBg{\n    background:  url('../CourseImages/CeoMsgBg.png');\n    background-size: cover;\n    background-position: center;\n    width: 100%;\n    height: auto;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    padding: 5%;\n}\n.PolymatchWords {\n    display: flex;\n    justify-content: center;\n    gap: -10px;\n    margin-top: 0px;\n    font-size: 1.8rem;\n    color: #6d0283;\n    font-family: 'Belanosima';\n}\n\n.PolymatchWords p {\n    margin: 0;\n    font-weight: bold;\n}\n.PolymatchWords p:nth-child(1) {\n    color: rgb(139, 1, 148);  /* Mastery */\n}\n\n.PolymatchWords p:nth-child(2) {\n    color: rgb(182, 3, 96);  /* Achieve */\n}\n\n.PolymatchWords p:nth-child(3) {\n    color: rgb(227, 206, 24);  /* Thrive */\n}\n\n.PolymatchWords p:nth-child(4) {\n    color: rgb(71, 150, 63);  /* Compete */\n}\n\n.PolymatchWords p:nth-child(5) {\n    color: rgb(227, 206, 24);  /* Hone */\n}\n\n.PolymatchHeading {\n    margin-top: 20px;\n    margin-bottom: 0px;\n    font-size: 1.5rem;\n    font-weight: bold;\n    color: rgb(182, 3, 96);\n    text-align: center;\n    font-family: 'Belanosima';\n}\n.PolymatchSection_1{\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n}\n.PolymatchSection_1 img{\n    width:30% ;\n    height: 30%;\n}\n.PolymatchSection_1 p{\n    padding: 0 1vh 0 1vh;\n    font-size: 2.5vh;\n    font-family: cursive;\n    font-weight: bold;\n    text-align: justify;\n    color: #8b0194;\n    width: 70%;\n    margin-bottom: 20px;\n}\n\n\n.PolymatchSection_2 {\n    display: flex;\n    flex-wrap: wrap; /* Allows wrapping of items */\n    align-items: center;\n    justify-content: space-between;\n    width: 80%;\n    gap: 10px; /* Consistent spacing */\n    margin-top: 20px; /* Add space above the section if needed */\n    margin-left: 10px;\n}\n.PolymatchSection_2 > div {\n    flex: 1 1 30%; /* Adjust the width of each item */\n    box-sizing: border-box; /* Ensures padding and border are included in the element's total width and height */\n    max-width: 30%;\n    text-align: center\n}\n.Polymatch_MathMental,.Polymatch_Islamic,.Polymatch_Linguist,.Polymatch_Science,.Polymatch_IQ{\n    background-color: #dbaf1f;\n    width: 300px; /* Set a fixed width */\n    height: 90px; /* Set a fixed height */\n    padding: 15px; /* Uniform padding */\n    border-radius: 8px; /* Rounded corners */\n    text-align: center;\n    cursor: pointer;\n    transition: background-color 0.3s ease; /* Smooth hover effect */\n    display: flex; /* Flex to center content */\n    flex-direction: column; /* Stack content vertically */\n    justify-content: center; /* Center content vertically */\n    align-items: center; /* Center content horizontally */\n}\n.Polymatch_Science{\n    background-color: rgba(231, 3, 182, 0.637)\n}\n.Polymatch_IQ{\n    background-color: rgba(236, 138, 25, 0.555)\n}\n.Polymatch_Islamic{\n    background-color: rgb(78, 237, 64)\n}\n\n.Polymatch_Linguist{\n    background-color: #688cd9;\n}\n\n.Polymatch_MathMental p,\n.Polymatch_Islamic p,\n.Polymatch_MathMental a,\n.Polymatch_Islamic a,\n.Polymatch_Linguist p,\n.Polymatch_Linguist a,\n.Polymatch_Science a,\n.Polymatch_Science p,\n.Polymatch_IQ a,\n.Polymatch_IQ p{\n    text-align: center;\n    color: white;\n    font-weight: bold;\n    font-size: medium;\n    align-items: center;\n    \n}\n\n\n.PolymatchSection_3 {\n    font-family: 'Comic Sans MS', cursive, sans-serif;\n    color: #730099;\n    background-color: #eaf6ff;\n    padding: 20px;\n    border-radius: 10px;\n    /* max-width: 800px; */\n    /* margin: 0 auto; */\n    text-align: center;\n    margin-left: 150px;\n}\n.Polymatch_header{\n    display: flex;\n    align-items: center;\n    justify-content: space-around;\n    margin-bottom: 0px;\n}\n.Polymatch_header h1 {\n    font-size: 36px;\n    margin: 0;\n}\n\n.Polymatch_header h2 {\n    font-size: 24px;\n    margin: 0;\n}\n\n.Polymatch_dateBadge {\n    background-color: #d399ff;\n    border-radius: 50%; /* Perfect circle */\n    padding: 0; /* Ensure no extra padding affects centering */\n    height: 16.5vh; /* Adjust the height */\n    width: 16.5vh; /* Match the width with height for a perfect circle */\n    display: flex;\n    justify-content: center; /* Horizontally center content */\n    align-items: center; /* Vertically center content */\n    white-space: nowrap; /* Prevent text wrapping */\n    text-align: center; /* Centers the text horizontally inside flex */\n    margin-right: 100px;\n    margin-left: 80px;\n    \n}\n.Polymatch_dateBadges {\n    background-color: #d399ff;\n    border-radius: 50%; /* Perfect circle */\n    padding: 0; /* Ensure no extra padding affects centering */\n    height: 16.5vh; /* Adjust the height */\n    width: 16.5vh; /* Match the width with height for a perfect circle */\n    display: flex;\n    justify-content: center; /* Horizontally center content */\n    align-items: center; /* Vertically center content */\n    white-space: nowrap; /* Prevent text wrapping */\n    text-align: center; /* Centers the text horizontally inside flex */\n    margin-right: 100px;\n    margin-left: 20px;\n}\n.Polymatch_dateBadges p {\n    margin: 0; /* Remove default paragraph margins */\n    font-size: 1.5vh; /* Adjust font size proportionally */\n    font-family: 'Barlow, sans-serif';\n    font-weight: bold;\n    text-align: center;\n}\n\n.Polymatch_dateBadge p {\n    margin: 0; /* Remove default paragraph margins */\n    font-size: 1.5vh; /* Adjust font size proportionally */\n    font-family: 'Barlow, sans-serif';\n    font-weight: bold;\n    text-align: center;\n}\n\n\n.Polymatch_content p {\n    padding: 10px;\n    border-radius: 10px;\n    margin: 80px 90;\n    text-align: justify;\n    font-weight: lighter;\n    margin-top: 0px;\n    margin-left: 90px;\n    font-family: Baumans; font-size: 20px; font-weight: 400\n}\n.results-btn {\n    display: inline-block; /* Ensures the button stays inline */\n    padding: 10px 20px; /* Adjust padding for proper alignment */\n    background: -webkit-linear-gradient(top, rgb(255, 255, 255) 0%, rgb(139, 1, 148) 100%);\n    background: linear-gradient(to bottom, rgb(255, 255, 255) 0%, rgb(139, 1, 148) 100%);\n    color: white;\n    text-align: center;\n    text-decoration: none;\n    font-size: 16px;\n    border-radius: 8px;\n    white-space: nowrap; /* Prevents text wrapping */\n    transition: background-color 0.3s ease;\n    margin-top: 0; /* Remove extra margin if causing misalignment */\n}\n\n.results-btn:hover {\n    background-color: #483d8b; /* Darker Slate Blue */\n}\n\n.reg-btn {\n    display: inline-block; /* Ensures the button stays inline */\n    padding: 10px 20px; /* Adjust padding for proper alignment */\n    background: -webkit-linear-gradient(top, rgb(255, 255, 255) 0%, rgb(139, 1, 148) 100%);\n    background: linear-gradient(to bottom, rgb(255, 255, 255) 0%, rgb(139, 1, 148) 100%);\n    color: white;\n    text-align: center;\n    text-decoration: none;\n    font-size: 16px;\n    border-radius: 8px;\n    white-space: nowrap; /* Prevents text wrapping */\n    transition: background-color 0.3s ease;\n    margin-top: 0; /* Remove extra margin if causing misalignment */\n    align-items: center;\n}\n\n.reg-btn:hover {\n    background-color: #483d8b; /* Darker Slate Blue */\n}\n\n.regs-button {\n    display: flex; /* Enables flexbox */\n    justify-content: center; /* Centers horizontally */\n    align-items: center; /* Centers vertically */\n    height: 100%; /* Adjust the height if needed */\n    width: 100%; /* Ensure it spans the full width of the container */\n    text-align: center; /* Aligns text if applicable */\n}\n\n\n.Polymatch_participantsSection {\n    margin-top: 20px;\n    margin-right: 150px;\n    width: fit-content;\n}\n\n.Polymatch_participantsSection h3 {\n    color: #ff5733;\n    font-size: 3vh;\n}\n\n.Polymatch_flagsGrid {\n    display: grid;\n    grid-template-columns: repeat(4, 1fr);\n    gap: 10px;\n    justify-items: center;\n    \n}\n.Polymatch_flagsGrids {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    gap: 5px;\n    justify-items: center;\n    \n}\n.Polymatch_flagsGridss {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    gap: 15px;\n    justify-items: center;\n    /* margin-right: 90px; */\n}\n.PolymatchFlagSection{\n    display: flex;\n    align-items: center;\n    /* justify-content: space-around; */\n    margin-left: 5vh;\n}\n.Polymatch_flag{\n    width: 80%;\n    height: 80%;\n}\n\n.gallery_container {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 20px;\n    justify-content: center;\n}\n\n.gallery_image {\n    width: 100%;\n    height: auto;\n    border-radius: 10px;\n}\n\n@media (max-width: 768px) {\n    .PolymatchSection_2{\n        flex-direction: column;\n    }\n    .PolymatchFlagSection{\n        flex-direction: column;\n        margin-left:0 ;\n    }\n    .Polymatch_content{\n        width: auto;\n    }\n    .Polymatch_content p{\n        text-align: justify;\n        width: 100%;\n    }\n    .Polymatch_dateBadge{\n        height: auto;\n        width: auto;\n    }\n}\n\n@media (max-width: 768px) {\n    .gallery_image {\n        max-width: 100%;\n    }\n}\n\n@media (max-width: 480px) {\n    .gallery_image {\n        max-width: 80%;\n    }\n}\n.PolymatchButtons {\n    display: flex;\n    gap: 20px;\n    margin-top: 20px;\n}\n\n.polymatch-btn {\n    background-color: rgb(139, 1, 148);\n    color: white;\n    padding: 15px 30px;\n    border-radius: 30px;\n    text-decoration: none;\n    font-weight: bold;\n    text-align: center;\n    transition: background-color 0.3s ease;\n    margin-bottom: 20px;\n    /* cursor: not-allowed; Change cursor to indicate the button is disabled  */\n    /* opacity: 0.6; Reduce opacity to make it look disabled */\n    /* pointer-events: none; Disable click events */\n}\n\n.polymatch-btn.details {\n    background-color: rgb(139, 1, 148);\n}\n\n.polymatch-btn:hover {\n    background-color: #e64e2d;\n}\n\n.polymatch-btn.details:hover {\n    background-color: #5078b4;\n}\n\n@media (max-width: 768px) {\n    .PolymatchButtons {\n        flex-direction: column;\n        align-items: center;\n        gap: 10px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
